<template>
    <div class="row text-left">
        <div class="col-10 mx-auto">
            <textarea class="form-control"
                      :class="{ 'json-error' : error }"
                      v-model="jsonInput"
                      rows="10"
                      ref="textarea"
                      placeholder="Write or paste JSON here..."
            ></textarea>
            <button class="btn btn-primary btn-block btn-lg mt-2" @click="prettyPrint()">Pretty Print</button>
            <div class="card bg-light mt-2 mb-5" v-show="jsonOutput">
                <div class="card-body">
                    <button class="btn btn-sm btn-copy btn-light"
                            ref="copybtn"
                            v-tooltip="{
                                content: 'Copy to clipboard',
                                // content: 'Copied!',
                                // trigger: 'click',
                                autoHide: true,
                            }"
                    >
                        <img class="clippy" src="../assets/clippy.svg" width="13" alt="Copy to clipboard">
                    </button>
                    <pre style="white-space:pre-wrap;" v-html="jsonOutput">
                    </pre>
                </div>
            </div>
            <div class="alert alert-danger mt-2 mb-5" v-show="error">{{error}}</div>
        </div>
        <!--<div class="col-10 mx-auto mt-5" v-if="jsonOutput">
            <pre>{{jsonOutput}}</pre>
        </div>-->
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .json-error::-moz-selection {
        color: white;
        background-color: red;
    }
    .json-error::selection {
        color: white;
        background-color: red;
    }

    .btn-copy {
        position: absolute;
        top: 0;
        right: 0;
    }
</style>

<script>
    /*

{
    "glossary": {
        "title": "example glossary",
		"GlossDiv": {
            "title": "S",
			"GlossList": {
                "GlossEntry": {
                    "ID": "SGML",
					"SortAs": "SGML",
					"GlossTerm": "Standard Generalized Markup Language",
					"Acronym": "SGML",
					"Abbrev": "ISO 8879:1986",
					"GlossDef": {
                        "para": "A meta-markup language, used to create markup languages such as DocBook.",
						"GlossSeeAlso": ["GML", "XML"]
                    },
					"GlossSee": "markup"
                }
            }
        }
    }
}
     */

    import Prism from 'prismjs';
    import 'prismjs/components/prism-json'; // need this
    import 'prismjs/themes/prism.css';
    import ClipboardJS from 'clipboard';


    export default {
        props: {
            msg: String
        },
        data() {
            return {
                jsonInput: "",
                jsonOutput: "",
                error: "",
            }
        },
        mounted() {
            new ClipboardJS(this.$refs.copybtn);
        },
        methods: {
            prettyPrint() {
                this.error = "";

                let jsonValue = "";
                try {
                    jsonValue = JSON.parse(this.jsonInput);
                    this.jsonOutput = JSON.stringify(jsonValue, null, 2);
                    this.jsonOutput = Prism.highlight(this.jsonOutput, Prism.languages.json);

                } catch (e) {
                    this.error = e.message;
                    this.jsonOutput = "";

                    const textarea = this.$refs.textarea
                    if (this.error.indexOf('position')>-1) {
                        // highlight error position
                        const positionStr = this.error.lastIndexOf('position') + 8;
                        const lastIndex = this.error.lastIndexOf('"');
                        let posi;
                        if (lastIndex > -1) {
                            posi = parseInt(this.error.substr(positionStr, lastIndex))
                        } else {
                            posi = parseInt(this.error.substr(positionStr))
                        }
                        if (posi >= 0) {
                            console.log("SELECT " + posi + " => " + (posi +1))
                            textarea.focus()
                            textarea.setSelectionRange(posi,posi+1)
                        }
                    }
                }
            }
        }
    }
</script>
